import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updatePlaceMetadata } from '../../api/place.ts';
import { UpdatePlaceMetadataRequest } from '../../api/requests/place-request.ts';

export default function useUpdatePlaceMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updatePlaceMetadata>>,
  Error,
  UpdatePlaceMetadataRequest
> {
  return useMutation({
    mutationFn: updatePlaceMetadata,
  });
}
